import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { displayDateFormatShort } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';

const SummaryPartialPaymentsListModal = ({ modal, list, currency, onClose }) => {
    if (!modal) return null;

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'View Summary Partial Payments', page_type })
    }

    const hasPaymentNo = list?.some(item => item?.payment_no);

    return (
        <Dialog aria-labelledby="summary-pp-list-title" className="add-lease-dialog" maxWidth="md" fullWidth open={true}>
            <DialogTitle sx={{ m: 0, p: 2, pl: 3 }} className="dialog-header" id="summary-pp-list-title">
                View Partial Payments
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer className="lease-detail-table" component={Paper}>
                    <Table className="mui-table-format" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Description</TableCell>
                                {hasPaymentNo && <TableCell>Payment No</TableCell>}
                                <TableCell>Payment Date</TableCell>
                                <TableCell align="center">Paid Amount</TableCell>
                                <TableCell align="right">Remaining Amount</TableCell>
                                <TableCell>Updated By</TableCell>
                                <TableCell>Last Updated</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list?.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item?.description || '--'}</TableCell>
                                    {hasPaymentNo && <TableCell>{item?.payment_no || '--'}</TableCell>}
                                    <TableCell>{item?.payment_date ? moment(item.payment_date).format(displayDateFormatShort) : '--'}</TableCell>
                                    <TableCell align="center">
                                        <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: currency, precision: 2, commafy: true, justification: 'L' }}>
                                            {item?.amount || 0}
                                        </NumericLabel>
                                    </TableCell>
                                    <TableCell align="right">
                                        <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: currency, precision: 2, commafy: true, justification: 'L' }}>
                                            {item?.remaining_amount || 0}
                                        </NumericLabel>
                                    </TableCell>
                                    <TableCell>{item?.user?.name || '--'}</TableCell>
                                    <TableCell>
                                        {item?.last_updated_at ? moment(item.last_updated_at).format(`${displayDateFormatShort} HH:mm`) : '--'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions sx={{ marginRight: '15px' }}>
                <Button className="cancel-btn" variant="outlined" size="small" onClick={() => { onClose(); handleItemClicked('Close Button') }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SummaryPartialPaymentsListModal;
